import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "text-center" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = {
  key: 0,
  class: "d-flex flex-column align-items-center justify-content-center",
  style: {"height":"300px"}
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "spinner-border spinner-border-lg text-primary mb-3" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_6 = { class: "text-center" }
const _hoisted_7 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_requirements = _resolveComponent("requirements")!
  const _component_download = _resolveComponent("download")!
  const _component_flag_english = _resolveComponent("flag-english")!
  const _component_flag_french = _resolveComponent("flag-french")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h1", _hoisted_1, _toDisplayString(_ctx.$t('title')), 1),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors, (error) => {
      return (_openBlock(), _createElementBlock("div", {
        key: error,
        class: "alert alert-danger",
        role: "alert"
      }, [
        _createTextVNode(_toDisplayString(error) + " ", 1),
        (error.startsWith('cURL error 60:'))
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              innerHTML: _ctx.$t('help.cUrl60', { path: _ctx.phpIniPath })
            }, null, 8, _hoisted_2))
          : _createCommentVNode("", true)
      ]))
    }), 128)),
    _createVNode(_Transition, {
      name: "fade",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (_ctx.preLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("h2", null, _toDisplayString(_ctx.$t('loading')), 1)
            ]))
          : (_ctx.step === 'requirements')
            ? (_openBlock(), _createBlock(_component_requirements, {
                key: 1,
                data: _ctx.data,
                loading: _ctx.loading,
                onReload: _ctx.reloadPage,
                onRefresh: _ctx.refreshRequirements,
                onNext: _ctx.showDownload
              }, null, 8, ["data", "loading", "onReload", "onRefresh", "onNext"]))
            : (_ctx.step === 'download')
              ? (_openBlock(), _createBlock(_component_download, {
                  key: 2,
                  loading: _ctx.loading,
                  onDownload: _ctx.download,
                  onError: _ctx.handleAxiosError
                }, null, 8, ["loading", "onDownload", "onError"]))
              : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _hoisted_5,
    _createElementVNode("footer", _hoisted_6, [
      _createVNode(_component_flag_english, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setLocale('en')))
      }),
      _createVNode(_component_flag_french, {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setLocale('fr')))
      }),
      _createElementVNode("p", {
        class: "mb-0",
        innerHTML: _ctx.$t('copyright', { year: new Date().getFullYear() })
      }, null, 8, _hoisted_7)
    ])
  ]))
}